const serviceTerms = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "This document outlines the terms governing the use of our car dealership services. By utilizing our vehicles, services, and solutions, you agree to adhere to the rules and policies set forth in this agreement."
    },
    { 
        id: "acceptable-use", 
        title: "2. Acceptable Use", 
        content: "Our vehicles and services must be used responsibly. Activities such as unauthorized modifications to the vehicle, unlawful use of the services, or any form of misuse are prohibited."
    },
    { 
        id: "subscription", 
        title: "3. Subscription Terms", 
        content: "Our services are available through customized packages, financing options, or leasing terms. Payments must be made as per the agreed timelines. Non-payment may result in service interruptions or vehicle repossession."
    },
    { 
        id: "user-obligations", 
        title: "4. User Obligations", 
        content: "Users are responsible for ensuring the safe and legal use of the vehicles. Please notify us immediately of any issues or concerns related to the vehicle or services you receive."
    },
    { 
        id: "limitation-liability", 
        title: "5. Limitation of Liability", 
        content: "[Car Dealer] shall not be liable for damages caused by misuse of the vehicles or services, or by circumstances beyond our control, as permitted by applicable laws."
    },
    { 
        id: "termination", 
        title: "6. Termination", 
        content: "We reserve the right to terminate services or agreements for violation of these Terms, misuse of the vehicles or services, or other applicable reasons. Notifications will be provided when applicable."
    },
    { 
        id: "intellectual-property", 
        title: "7. Intellectual Property", 
        content: "All logos, trademarks, and designs associated with our car dealership and services are the intellectual property of [Car Dealer]. These may not be copied, modified, or redistributed without our consent."
    },
    { 
        id: "governing-law", 
        title: "8. Governing Law", 
        content: "These Terms are governed by the laws of [Jurisdiction]. Any disputes will be resolved under the jurisdiction of the courts in [City/Region]."
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: "If you have any questions or concerns regarding these Terms, please contact us at support@[cardealer].com or call +[Phone Number]."
    }
];

export default serviceTerms;